import { QueryClientProvider } from "@tanstack/react-query";
import { ToastContainer } from "react-toastify";
import { ThemeProvider } from "styled-components";
import { WagmiProvider } from "wagmi";

import { App } from "@/pages/App";
import { queryClient, wagmiConfig } from "@/services/config/evm";
import { theme } from "@/theme";
import GlobalStyles from "@/theme/globalStyles";

import { AccountsProvider } from "./accounts-provider";
import { ModalProvider } from "./modal-provider";
import { WalletSelectorContextProvider } from "./near-provider";
import { SolanaProvider } from "./solana-provider";
import { TonProvider } from "./ton-provider";

export const Providers = () => {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <TonProvider>
        <WalletSelectorContextProvider>
          <WagmiProvider config={wagmiConfig}>
            <QueryClientProvider client={queryClient}>
              <SolanaProvider>
                <ModalProvider>
                  <AccountsProvider>
                    <ToastContainer />
                    <App />
                  </AccountsProvider>
                </ModalProvider>
              </SolanaProvider>
            </QueryClientProvider>
          </WagmiProvider>
        </WalletSelectorContextProvider>
      </TonProvider>
    </ThemeProvider>
  );
};
